<template>
  <div class="authWrapper">
    <div class="container">
      <div class="row whiteBG-wrap">
        <div class="col-lg-6 col-md-6 no-padding">
          <div class="left-bg-wrapper text-center">
            <h1>Hello</h1>
            <p>Please enter otp to upload your file.</p>
          </div>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="auth-form-wrap auth-form">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form
                @submit.stop.prevent="handleSubmit(uploadFile)"
                ref="addFileContainer"
              >
                <div class="row">
                  <input-text
                    :rules="form.doc_type === 'SSN' || form.doc_type === 'EIN' ? {} : { required: true }"
                    v-if="form.doc_type !== 'SSN' && form.doc_type !== 'EIN'"
                    labelFor="uploaded_by"
                    labelName="Name"
                    inputName="name"
                    :vmodel.sync="form.uploaded_by"
                    formGroupClass="form-group col-lg-6 col-md-6 mb-3"
                    :api-errors="apiErrors"
                  />

                  <input-text
                    :rules="form.doc_type === 'SSN' || form.doc_type === 'EIN' ? {} : { required: true }"
                    v-if="form.doc_type !== 'SSN' && form.doc_type !== 'EIN'"
                    labelFor="file_title"
                    labelName="File Title"
                    inputName="file_title"
                    :vmodel.sync="form.file_title"
                    formGroupClass="form-group col-lg-6 col-md-6 mb-3"
                    :api-errors="apiErrors"
                  />
                </div>
                <div class="row">
                  <input-multi-select
                    labelFor="doc_type"
                    :vmodel.sync="form.doc_type"
                    labelName="Type"
                    :options="fileTypes.map((type) => type.value)"
                    :custom-label="
                      (opt) => fileTypes.find((x) => x.value == opt).text
                    "
                    :rules="{ required: true }"
                    formGroupClass="form-group col-lg-12 col-md-12 mb-3"
                    placeholder="Select File Type"
                    :api-errors="apiErrors"
                  />
                </div>

                <!-- SSN Form -->
                <div class="row" v-if="form.doc_type === 'SSN'">
                  <div class="col-lg-12 col-md-12 mb-3">
                    <div class="form-group mb-3 position-relative">
                      <label for="ssn" class="form-label">Social Security Number (SSN)</label>
                      <div class="input-group">
                        <input
                          :type="showSSN ? 'text' : 'password'"
                          class="form-control"
                          id="ssn"
                          name="ssn"
                          placeholder="Enter 9-digit SSN"
                          v-model="form.ssn"
                          maxlength="9"
                          @input="validateSSN"
                          @keypress="onlyNumbers"
                        />
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="showSSN = !showSSN"
                          style="border-left: none;"
                        >
                          <i :class="showSSN ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                      </div>
                      <div class="valid-error mt-2" v-if="ssnError">
                        {{ ssnError }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- EIN Form -->
                <div class="row" v-if="form.doc_type === 'EIN'">
                  <div class="col-lg-12 col-md-12 mb-3">
                    <div class="form-group mb-3 position-relative">
                      <label for="ein" class="form-label">Employer Identification Number (EIN)</label>
                      <div class="input-group">
                        <input
                          :type="showEIN ? 'text' : 'password'"
                          class="form-control"
                          id="ein"
                          name="ein"
                          placeholder="Enter 9-digit EIN"
                          v-model="form.ein"
                          maxlength="9"
                          @input="validateEIN"
                          @keypress="onlyNumbers"
                        />
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="showEIN = !showEIN"
                          style="border-left: none;"
                        >
                          <i :class="showEIN ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                      </div>
                      <div class="valid-error mt-2" v-if="einError">
                        {{ einError }}
                      </div>
                    </div>
                  </div>
                </div>

                <input-file
                  v-if="form.doc_type !== 'SSN' && form.doc_type !== 'EIN'"
                  :rules="form.doc_type !== 'SSN' && form.doc_type !== 'EIN' ? { required: true, mimes: mimeTypes } : {}"
                  labelFor="file"
                  labelName="Select File (txt, png, jpg, jpeg, xlsx, pdf, csv, doc and pptx) "
                  inputName="select_file"
                  :vmodel.sync="file"
                  :acceptMimeTypes="mimeTypes"
                  :api-errors="apiErrors"
                  formGroupClass="form-group mb-3"
                />
                <input-textarea
                  v-if="form.doc_type !== 'SSN' && form.doc_type !== 'EIN'"
                  :rules="form.doc_type !== 'SSN' && form.doc_type !== 'EIN' ? { required: true } : {}"
                  labelFor="file"
                  labelName="File Notes "
                  inputName="file"
                  :vmodel.sync="form.doc_notes"
                  formGroupClass="form-group mb-3"
                  :api-errors="apiErrors"
                />

                <div class="auth-form upload-file-share-btn" @keypress="onlyNumbers">
                  <h5>Enter OTP</h5>
                  <v-otp-input
                    ref="otpInput"
                    :input-classes="errorClass +' otp-input'"
                    separator=""
                    :num-inputs="6"
                    :should-auto-focus="true"
                    :is-input-num="true"
                    @on-change="handleOnChange"
                    @on-complete="handleOnComplete"
                    input-type="text"
                  />
                  <div class="valid-error mt-2"  v-if="apiErrors && apiErrors.otp">
                    {{ apiErrors.otp[0] }}
                  </div>
                </div>
                <div class="col-md-12 upload-file-action">
                  <button
                    type="submit"
                    :class="isOtpComplete ? 'submit-btn' : 'disable-submit-btn'"
                    :disabled="isUpload || !isOtpComplete "
                  >
                    {{ isUpload ? "Uploading...." : "Upload" }}
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

let axiosInstance = axios.create({ headers: "" });
axiosInstance.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
const formData = {
  file_title: "",
  doc_notes: "",
  doc_type: null,
  otp: "",
  platform_user_id: "",
  platform_user_type: "",
  uploaded_by: "",
  ssn: "",
  ein: "",
};
export default {
  name: "UploadFileShare",
  data: () => ({
    isOtpComplete: false,
    isUpload: false,
    showSSN: false,
    showEIN: false,
    ssnError: null,
    einError: null,
    form: {
      ...formData,
    },
    file: null,
    fileTypes: [
      { value: "My Files", text: "My Files" },
      { value: "Forms", text: "Forms" },
      { value: "Enrollment Form", text: "Enrollment Form" },
      { value: "Census File", text: "Census File" },
      { value: "Member Docs", text: "Member Docs" },
      { value: "Rep Doc", text: "Rep Doc" },
      { value: "Commission Statement", text: "Commission Statement" },
      { value: "SSN", text: "SSN" },
      { value: "EIN", text: "EIN (Business Tax ID)" },
    ],
    apiErrors: null,
    isCreate: false,
    mimeTypes: [
      "application/doc",
      "application/ms-doc",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-powerpoint",
      "application/mspowerpoint",
      "application/powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/excel",
      "application/x-msexcel",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
      "application/pdf",
      "text/csv",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ],
    errorClass: "",
  }),
  computed: {
    ...mapGetters({ rep: "rep" }),
  },
  methods: {
    onlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    validateSSN() {
      if (!this.form.ssn) {
        this.ssnError = 'SSN is required';
      } else if (!/^\d{9}$/.test(this.form.ssn)) {
        this.ssnError = 'SSN must be exactly 9 digits';
      } else {
        this.ssnError = null;
      }
    },
    validateEIN() {
      if (!this.form.ein) {
        this.einError = 'EIN is required';
      } else if (!/^\d{9}$/.test(this.form.ein)) {
        this.einError = 'EIN must be exactly 9 digits';
      } else {
        this.einError = null;
      }
    },
    setData() {
      this.form = {
        file_title: "",
        doc_notes: "",
        doc_type: null,
        otp: "",
        platform_user_id: this.rep.id,
        platform_user_type: "REP",
        uploaded_by: "",
        ssn: "",
        ein: "",
      };
      this.ssnError = null;
      this.einError = null;
      this.showSSN = false;
      this.showEIN = false;
       if(this.$route.query.name){
      this.form.uploaded_by = this.$route.query.name
      this.$nextTick(() => {
        this.$router.replace({'query': null});
      })
    }
    },
    async uploadFile() {
      if (this.form.doc_type === 'SSN' && (!this.form.ssn || !/^\d{9}$/.test(this.form.ssn))) {
        this.$notify('Please enter a valid 9-digit SSN', 'error');
        return;
      }
      if (this.form.doc_type === 'EIN' && (!this.form.ein || !/^\d{9}$/.test(this.form.ein))) {
        this.$notify('Please enter a valid 9-digit EIN', 'error');
        return;
      }

      // Use different API endpoints for SSN and EIN
      let url;
      if (this.form.doc_type === 'SSN') {
        url = `api.access/v2/file-share/update-ssn`;
      } else if (this.form.doc_type === 'EIN') {
        url = `api.access/v2/file-share/update-ein`;
      } else {
        url = `api.access/v2/file-share/upload`;
      }
      let formData = new FormData();
      
      if (this.form.doc_type !== 'SSN' && this.form.doc_type !== 'EIN' && this.file) {
        formData.append("file", this.file);
      }
      
      for (const [key, value] of Object.entries(this.form)) {
        if (key === 'ssn' && this.form.doc_type !== 'SSN') continue;
        if (key === 'ein' && this.form.doc_type !== 'EIN') continue;
        if ((key === 'file_title' || key === 'doc_notes') && (this.form.doc_type === 'SSN' || this.form.doc_type === 'EIN')) continue;
        
        if (value) {
          formData.append(key, value);
        }
      }
      this.isUpload = true;
      let loader = this.$loading.show();
      await axiosInstance
        .post(url, formData)
        .then((res) => {
          this.handleClearInput();
          this.$notify(res.data.message);
        })
        .catch((err) => {
          if (err.response.status == 422) {
            this.apiErrors = err.response.data.errors;
            this.errorClass = 'highlight_otp'
          } else {
            this.$notify(err.response.data.message, "error");
          }
        })
        .finally(() => {
          this.isUpload = false;
          loader.hide();
        });
    },
    handleOnComplete(value) {
      this.isOtpComplete = true;
      this.form.otp = value;
    },
    handleOnChange(value) {
      this.form.otp = value;
      this.apiErrors = null;
      this.errorClass = '';

      if(this.form.otp.length == 6){
        this.isOtpComplete = true
      }
      else{
        this.isOtpComplete = false
      }
    },
    handleClearInput() {
      this.form = { ...formData };
      this.$refs.otpInput.clearInput();
      this.$refs.observer.reset();
      this.apiErrors = null;
      this.ssnError = null;
      this.einError = null;
      this.showSSN = false;
      this.showEIN = false;
    },
  },
  watch: {
    'form.doc_type'(newVal, oldVal) {
      if (oldVal === 'SSN' && newVal !== 'SSN') {
        this.form.ssn = '';
        this.ssnError = null;
        this.showSSN = false;
      }
      if (oldVal === 'EIN' && newVal !== 'EIN') {
        this.form.ein = '';
        this.einError = null;
        this.showEIN = false;
      }
      if (newVal !== 'SSN') {
        this.ssnError = null;
        this.showSSN = false;
      }
      if (newVal !== 'EIN') {
        this.einError = null;
        this.showEIN = false;
      }
    }
  },
  created() {
    this.setData();
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style>
.highlight_otp {
  border: 2px solid red !important;
}

button.disable-submit-btn {
  width: 100%;
  border: 0;
  background: rgb(172, 202, 209);
  color: #fff;
  padding: 13px;
  font-weight: 600;
  border-radius: 6px;
  outline: none;
  transition: all ease 0.6s;
}

.otp-error {
  padding-left: 12px;
}

.upload-file-share-btn {
  padding: 0;
}

.upload-file-action {
  margin-top: 20px;
}

.valid-error {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
</style>
